// icon:bx-shield-alt | Boxicons https://boxicons.com/ | Atisa
import * as React from "react";
import Icon from "../../images/art/icons/Army.png";

function IconBxShieldAlt(props) {
	return (
		<img src={Icon} style={{ height: '1em', width: '1em', ...props }} alt={"Army"} />
	)
}

export default IconBxShieldAlt;
